import React from 'react';
import cn from 'classnames';
import TierConsumerReduxModule from '../../Tier/redux/consumer/ModuleLoadable';
import SubscribeVariant from './variants/Subscribe';
import UnsubscribeVariant from './variants/Unsubscribe';
import ViewVariant from './variants/View';
import DisabledVariant from './variants/Disabled';
import s from './SubscribeButton.scss';
var SubscribeButton = function (_a) {
    // TODO: this (or the ds button itself) really needs a focus-visible ring
    var tier = _a.tier, _b = _a.tier.tier, _c = _b === void 0 ? {} : _b, isUserSubscribed = _c.isUserSubscribed, canUserSubscribe = _c.canUserSubscribe, withPrice = _a.withPrice, showUnsubAsView = _a.showUnsubAsView, className = _a.className, href = _a.href, size = _a.size, onSubscribe = _a.onSubscribe, onUnsubscribe = _a.onUnsubscribe;
    var buttonElement;
    if (isUserSubscribed) {
        if (showUnsubAsView) {
            buttonElement = (React.createElement(ViewVariant, { tier: tier, className: cn(className, s['centered']), size: size }));
        }
        else {
            buttonElement = (React.createElement(UnsubscribeVariant, { tier: tier, className: cn(className, s['centered']), href: href, size: size, onUnsubscribe: onUnsubscribe }));
        }
    }
    else if (!canUserSubscribe) {
        buttonElement = (React.createElement(DisabledVariant, { className: cn(className, s['centered']), size: size }));
    }
    else {
        buttonElement = (React.createElement(SubscribeVariant, { tier: tier, className: className, withPrice: withPrice, href: href, size: size, onSubscribe: onSubscribe }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TierConsumerReduxModule, null),
        buttonElement));
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map